<bit-nav-item
  [text]="'sponsoredFamilies' | i18n"
  route="settings/sponsored-families"
  *ngIf="showFreeFamilies$ | async"
></bit-nav-item>
